import { z } from "zod";

/**
 * NxAdminAgentMessage.toolCalls JSON field schema.
 *
 * An assistant turn records the tool activity it performed as an array of
 * `{ name, args, status }`. `status` is the HTTP status of the tool's real
 * route call (absent while a call is still in flight). This is the single
 * source of truth for the Json field: the backend mapper `safeParse`s it and
 * the NexusApi message DTO reuses it, so the shape can never drift.
 */
export const AdminAgentToolCallSchema = z.object({
  name: z.string(),
  args: z.record(z.string(), z.unknown()),
  status: z.number().int().optional()
});

export type AdminAgentToolCall = z.infer<typeof AdminAgentToolCallSchema>;

export const AdminAgentToolCallsSchema = z.array(AdminAgentToolCallSchema);

export type AdminAgentToolCalls = z.infer<typeof AdminAgentToolCallsSchema>;
